// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","logo":"Footer_logo__B7si-","companyInfo":"Footer_companyInfo__CFkyg","line":"Footer_line__yt6y0","copyright":"Footer_copyright__FJOSH"};